<template>
  <modal
    :show.sync="isOpenLocal"
    scrollable
    header-classes="bg-primary p-2 flex items-center"
    size="lg"
    @close="handleClose"
  >
    <!-- <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Add News
    </h6> -->
    <h6 class="modal-title text-black font-semibold">Update Cover Image</h6>
    <div>
      <div class="w-full relative pt-3">
        <!-- <img
          src="@/assets/images/wgrid4.jpg"
          class="w-full h12 rounded-t-2xl"
        /> -->

        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <img
          v-if="image"
          :src="image"
          ref="cover"
          class="w-full h12 rounded-t-2xl object-contain"
        />

        <div class="absolute top-0 right-0 rounded-full">
          <b-dropdown
            no-caret
            size="lg"
            variant="link"
            right
            toggle-class="text-decoration-none z-10 text-transparent hover:text-transparent"
            id="dropdown-1"
          >
            <template #button-content>
              <feather-icon
                icon="Edit2Icon"
                class="cursor-pointer text-primary"
                svgClasses="w-4 h-4 "
              ></feather-icon>
            </template>

            <b-dropdown-item @click="HandleDelete()">Delete</b-dropdown-item>
          </b-dropdown>
        </div>

        <!-- <div
          class="profilephoto flex justify-center w-full rounded-full absolute"
        >
          <div class="relative rounded-full h-28 w-28 border6 olv">
            <img
              src="@/assets/images/courses/4.png"
              class="object-cover w-full h-full rounded-full profimage"
            />

          
            <div
              class="absolute flex top-5 w-full justify-center middle rounded-full p-2"
            >
              <b-dropdown
                size="lg"
                variant="link"
                toggle-class="text-decoration-none  text-transparent hover:text-transparent"
                no-caret
                id="dropdown-1"
              >
                <template #button-content>
                  <feather-icon
                    icon="Edit2Icon"
                    class="cursor-pointer text-white"
                    svgClasses="w-5 h-5"
                  ></feather-icon>
                </template>
                <b-dropdown-item @click="HandleEdit()"> Edit</b-dropdown-item>
                <b-dropdown-item>Delete</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <template slot="footer" class="justify-center">
      <base-button type="primary" @click="handleClick(data.role)"
        >SAVE CHANGES</base-button
      >
      <base-button
        type="secondary"
        class="ml-auto border"
        @click="handleClose()"
        >CLOSE</base-button
      >
    </template>
  </modal>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import { mapState } from "vuex";
export default {
  data() {
    return {
      image: null,
      coverImage: null,
      // users: [
      //   { value: null, text: "select Designation", disable: "true" },
      //   "Student",
      //   "Teacher",
      // ],
    };
  },
  components: {
    FileUploader,
  },
  props: {
    isOpen: Boolean,
    data: { type: Object },
  },
  computed: {
    ...mapState("auth", ["userData"]),
    isOpenLocal: {
      get() {
        return this.isOpen;
      },
      set(val) {
        if (!val) {
          this.handleClose();
        }
      },
    },
  },
  methods: {
    handleSuccess(image) {
      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    HandleDelete() {
      this.image = null;
      this.coverImage = null;
    },

    handleClick(role) {
      if (role === "student") {
        this.editStudentDetail();
      } else {
        this.editAuthorDetail();
      }
    },
    async editStudentDetail() {
      let FormData = require("form-data");
      let payload = new FormData();
      payload.append("_id", this.userData._id);
      payload.append("coverimage", this.coverImage);
      this.handleClose();
      this.$swal.fire({
        text: " Cover Image updated successfully",
        icon: "success",
        confirmButtonText: "Okay",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
      await this.$store.dispatch("eLearning/editUser", payload);
      await this.$store.dispatch("eLearning/getProfile", {
        userId: this.userData._id,
      });
    },
    async editAuthorDetail() {
      let FormData = require("form-data");
      let payload = new FormData();
      payload.append("_id", this.userData._id);
      payload.append("coverimage", this.coverImage);
      this.handleClose();
      this.$swal.fire({
        text: " Cover Image updated successfully",
        icon: "success",
        confirmButtonText: "Okay",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
      await this.$store.dispatch("eLearning/editUser", payload);
      await this.$store.dispatch("eLearning/getProfile", {
        userId: this.userData._id,
      });
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
